import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import AboutMe from "../components/AboutMe";
import Experience from "../components/Experience";
import Projects from "../components/Projects";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

function Home() {
  return (
    <React.Fragment>
      <Navbar />
      <Hero />
      {/* <AboutMe /> */}
      <Experience />
      <Projects />
      <Contact />
      <Footer />
    </React.Fragment>
  );
}

export default Home;
